type Props = {
  /** Violet is the product default; emerald marks the ATS booster as its own tool. */
  variant?: "violet" | "emerald";
};

/**
 * Blurred aurora backdrop shared by every app screen. Kept deliberately soft so the
 * hairline surfaces on top of it stay readable in both themes.
 */
export function MeshBackground({ variant = "violet" }: Props) {
  const isEmerald = variant === "emerald";

  return (
    <div className="pointer-events-none fixed inset-0 -z-10 h-screen w-screen select-none overflow-hidden">
      {/* Top diagonal sweeping aurora wave */}
      <div
        className={`absolute -top-[15%] left-[-20%] h-[700px] w-[1000px] rotate-[-15deg] rounded-[100%] blur-[120px] ${
          isEmerald
            ? "bg-gradient-to-tr from-emerald-300/60 via-teal-200/40 to-amber-100/30 dark:from-emerald-950/50 dark:via-teal-950/30 dark:to-transparent"
            : "bg-gradient-to-tr from-violet-300/60 via-indigo-200/40 to-amber-100/30 dark:from-violet-950/50 dark:via-indigo-950/30 dark:to-transparent"
        }`}
      />

      {/* Middle/right fluid gradient mesh */}
      <div
        className={`absolute top-[10%] right-[-15%] h-[650px] w-[900px] rotate-[18deg] rounded-[100%] blur-[130px] ${
          isEmerald
            ? "bg-gradient-to-bl from-teal-400/45 via-emerald-300/35 to-yellow-100/40 dark:from-teal-900/40 dark:via-emerald-900/30 dark:to-transparent"
            : "bg-gradient-to-bl from-indigo-400/45 via-violet-300/35 to-amber-100/40 dark:from-indigo-900/40 dark:via-violet-900/30 dark:to-transparent"
        }`}
      />

      {/* Bottom-left soft warm accent glow */}
      <div
        className={`absolute bottom-[-10%] left-[5%] h-[450px] w-[700px] rotate-[-8deg] rounded-[100%] blur-[100px] ${
          isEmerald
            ? "bg-gradient-to-r from-yellow-200/35 via-emerald-200/30 to-teal-100/20 dark:from-emerald-950/40 dark:to-transparent"
            : "bg-gradient-to-r from-amber-200/30 via-violet-200/30 to-indigo-100/20 dark:from-violet-950/40 dark:via-none dark:to-transparent"
        }`}
      />
    </div>
  );
}
